import { getCookie } from "@/helpers/auth";
import { useUserStore } from "@/store/userStore";

function getDefaultHeaders(contentType?: string) {
  const userStore = useUserStore();
  const headers: Record<string, string | null | undefined> = {
    "X-CSRFToken": getCookie("csrftoken"),
    Authorization: userStore.getUserInfo.value?.assets_api_key
      ? `Bearer ${userStore.getUserInfo.value.assets_api_key}`
      : undefined,
  };

  if (contentType) {
    headers["Content-Type"] = contentType;
  }

  return headers;
}

export function fetchOptions(method: string, body?: any, contentType?: string):RequestInit {
  return {
    method,
    headers: getDefaultHeaders(contentType),
    credentials: "include" as RequestCredentials,
    body: body ? JSON.stringify(body) : null,
  };
}

export function fileOptions(method: string, data?: FormData) {
  return {
    method,
    headers: getDefaultHeaders(),
    credentials: "include" as RequestCredentials,
    body: data
  };
}

export { getDefaultHeaders };
